import { useMemo } from "react";
import { getAnomalyId } from "../utils/utilities";
import { NewAnomalyItem } from "../utils/models";

interface MappedAnomaly {
    id: number;
    anomalyItems: NewAnomalyItem[];
}

export interface MappedAnomalyOption {
    anomalyId: string;
    id: number;
    name: string;
}

export const getMappedAnomalies = (mappedAnomaly: MappedAnomaly): MappedAnomalyOption[] => {
    return mappedAnomaly.anomalyItems.map((anomaly, index) => ({
        anomalyId: getAnomalyId(mappedAnomaly.id, index + 1),
        id: anomaly.id,
        name: anomaly.id.toString(),
    }));
};

export const useMappedAnomalies = (mapped: MappedAnomaly[]): MappedAnomalyOption[] => {
    const mappedItems: MappedAnomalyOption[] = useMemo(() => {
        return mapped.flatMap((mappedItem) => getMappedAnomalies(mappedItem));
    }, [mapped]);

    return mappedItems;
};

export default useMappedAnomalies;